import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../mensajes2';
import { Dimmer } from '../../spinner';
import moment from 'moment';

export const ImpDeudaGeneralInm = (props) => {
    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [tipoContribuyente, setTipoContribuyente] = useState('');

    const [report, setReport] = useState('');
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCredito = useRef();
    const txtEjecucion = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();

    const txtOrdenarPor = useRef();
    const txtDeudaDesdeAnio = useRef();
    const chkMostrarPagos = useRef();
    const chkActivo = useRef();
    const chkInactivo = useRef();
    const chkClausurado = useRef();
    const chkFiscal = useRef();
    const chkNotificado = useRef();
    const chkDepLegal = useRef();
    const chkExonerado = useRef();
    const chkEnproceso = useRef();
    const radGeneral = useRef();
    const radDetallado = useRef();
    const radDetalladoMensual = useRef();
    const radCodigoAnterior = useRef();
    const radCodigoActual = useRef();
    const txtDesdeSectorCatastral = useRef();
    const txtHastaSectorCatastral = useRef();
    const cmbUsoInmueble = useRef();
    const txtDeudaDesdeAnioInput = useRef();
    const txtAlDia = useRef();

    const [tipoReporte, setTipoReporte] = useState('');
    const [deudaDesdeAnio, setDeudaDesdeAnio] = useState({
        Activo: false,
        Inactivo: false,
        Clausurado: false,
        Fiscal: false,
        Notificado: false,
        DepLegal: false,
        Exonerado: false,
        RevCerrado: false
    });

    console.log(tipoReporte)
    const onChangeValidar = (e) => {
        e.preventDefault();

        let uso = '';
        let crite = '';
        let val2 = '';
        let sql = '';
        let sql2 = '';
        let sql3 = '';
        let fileName = ''
        let TIT_CRI1 = cmbUsoInmueble.current.value.toString() === 'TODOS' ? "Contribuyentes Inmuebles Urbanos" : "INMUEBLES URBANOS USO " + cmbUsoInmueble.current.value;
        const activo = chkActivo.current.checked ? "61," : "0,";
        const inactivo = chkInactivo.current.checked ? "62," : "0,";
        const enProceso = chkEnproceso.current.checked ? "63" : "0";

        const status_cade = activo + inactivo + enProceso;

        if (cmbUsoInmueble.current.value.toString() !== 'TODOS') {
            uso = " AND usoterreno = '"
                + cmbUsoInmueble.current.value + "'";
        } else {
            uso = " AND TRUE";
        }

        if (radCodigoAnterior.current.checked) {
            // crit="N";
            crite = " (SECTORN between " + "'"
                + txtDesdeSectorCatastral.current.value + "'"
                + " and " + "'"
                + txtHastaSectorCatastral.current.value + "'"
                + ") " + uso;
        } else {
            // crit="V";
            crite = " (SECTOR between " + "'"
                + txtDesdeSectorCatastral.current.value + "'"
                + " and " + "'"
                + txtHastaSectorCatastral.current.value + "'"
                + ")" + uso;
        }

        console.log(crite)
        val2 = moment.utc(txtAlDia.current.value).format('DD-MM-YYYY')
        sql = "'" + val2 + "'";
        sql2 = "al Día" + " " + "'" + val2 + "'";

        if (radGeneral.current.checked) {
            fileName = "Geco_DeudaInm";
            // sql3 = " true ";
            sql3 = "INM.EDO IN (" + status_cade + ")"
                + uso;
        } else {
            sql3 = "INM.EDO IN (" + status_cade + ")"
                + uso;
            fileName = "Geco_DeudaInmDetallado";
        }

        window.open(
            op.reportes + "/inmueblesurbanos?" +
            "reporte=" +
            fileName +
            "&efiscal=" +
            idefiscal +
            "&CONDICION=" +
            sql3 +
            "&SECTOR=" +
            crite +
            "&FECHA=" +
            sql.trim() +
            "&TIT_RGO1=" +
            sql2.trim() +
            "&TIT_CRI1=" +
            TIT_CRI1 +
            "&VENCIDO= Inm.fechaavaluo > '31-12-2005'" +
            "&ANIODEUDA=" +
            txtDeudaDesdeAnioInput.current.value,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

    };

    const onChange = (e) => {

        if (e.target.id = 'tipoContribuyente') {
            setTipoContribuyente(e.target.value)
        }

    };

    const onCheck = (e) => {
        if (e.target.id === 'credito') {
            setReport('Pres_IngrEdoEjecCredi');
            setActivo(false);
        } else if (e.target.id === 'ejecucion') {
            if (espiritu === 0) {
                setReport('Pres_IngrEdoEjecOrd1');
            } else {
                setReport('Pres_IngrEdoEjecOrd');
            }
            setActivo(false);
        } else if (e.target.name === 'tipoReporte') {
            setTipoReporte(e.target.value);
        } else if (e.target.name === 'deudaDesdeAnio') {
            setDeudaDesdeAnio({
                ...deudaDesdeAnio,
                [e.target.value]: e.target.checked
            });
        }
    };

    const imprimirEstadoFinancieroPresupuesto = (desde, hasta) => {
        var reporte = report;
        let desdec = "'" + moment.utc(desde).format('DD-MM-YYYY') + "'";
        let hastac = "'" + moment.utc(hasta).format('DD-MM-YYYY') + "'";
        let dia = hasta.substring(8, 10);
        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + dia + "&sql3=" + desdec + "&sql4=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    };

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    };

    const blanquear = () => {

        txtOrdenarPor.current ? txtOrdenarPor.current.value = '' : '';
        txtDeudaDesdeAnio.current ? txtDeudaDesdeAnio.current.value = '' : '';
        chkMostrarPagos.current ? chkMostrarPagos.current.checked = false : '';
        setActivo(true);
        setTipoReporte('General');
        setDeudaDesdeAnio({
            Activo: false,
            Inactivo: false,
            Clausurado: false,
            Fiscal: false,
            Notificado: false,
            DepLegal: false,
            Exonerado: false,
            RevCerrado: false
        });
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    };

    // Función para manejar el evento onChange y validar que solo se ingresen números
    const handleInputChange = (e) => {
        const value = e.target.value;
        // Solo permite números y limita la longitud a 2 caracteres
        if (/^\d{0,2}$/.test(value)) {
            e.target.value = value;
        } else {
            e.target.value = value.slice(0, 2).replace(/\D/g, ''); // Elimina caracteres no numéricos
        }
    };

    // Función para agregar un 0 adelante si la longitud es 1
    const agregarCeroAdelante = (value) => {
        return value.length === 1 ? `0${value}` : value;
    };

    // Función para manejar el evento onBlur
    const handleInputBlur = (e) => {
        const desde = txtDesdeSectorCatastral.current.value;
        const hasta = txtHastaSectorCatastral.current.value;

        // Agrega un 0 adelante si la longitud es 1
        txtDesdeSectorCatastral.current.value = agregarCeroAdelante(desde);
        txtHastaSectorCatastral.current.value = agregarCeroAdelante(hasta);

        // Validar que "Desde" no sea mayor que "Hasta"
        const desdeNum = parseInt(txtDesdeSectorCatastral.current.value, 10);
        const hastaNum = parseInt(txtHastaSectorCatastral.current.value, 10);

        if (desdeNum > hastaNum) {
            // Intercambia los valores si "Desde" es mayor que "Hasta"
            txtDesdeSectorCatastral.current.value = agregarCeroAdelante(hasta);
            txtHastaSectorCatastral.current.value = agregarCeroAdelante(desde);
        }
    };
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setHasta(fech);
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'>Lstado de Deudas de Contribuyentes de Inmuebles Urbanos.</div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Dimmer active={activate} inverted></Dimmer>

                <div className="col-md-12 row mx-auto px-0">


                    <div className='row m-0 px-0 border-azul rounded py-2 mb-1 '>
                        <label className="fw-bold col my-auto ">Buscar por</label>
                        <div class="form-check col">
                            <input class="form-check-input my-auto" defaultChecked type="radio" name="flexRadioDefault" id="flexRadioDefault1" ref={radCodigoAnterior} />
                            <label class="form-check-label my-auto" for="flexRadioDefault1">
                                Codigo Anterior
                            </label>
                        </div>
                        <div class="form-check col">
                            <input class="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault2" ref={radCodigoActual} />
                            <label class="form-check-label my-auto" for="flexRadioDefault2">
                                Codigo Actual
                            </label>
                        </div>

                    </div>
                    <div className="input-group input-group-sm mb-1 col-md-6 pl-0">
                        <span className="input-group-text" id="inputGroup-sizing-sm">Desde Sector Catastral N°:</span>
                        <input
                            type="text"
                            defaultValue={'01'}
                            className="form-control text-uppercase"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            ref={txtDesdeSectorCatastral}
                            onChange={handleInputChange} // Valida que solo se ingresen números
                            onBlur={handleInputBlur} // Agrega un 0 adelante si la longitud es 1
                            maxLength={2} // Limita la longitud máxima a 2 caracteres
                        />
                    </div>
                    <div className="input-group input-group-sm mb-1 col-md-6 pr-0">
                        <span className="input-group-text" id="inputGroup-sizing-sm">Hasta Sector Catastral N°:</span>
                        <input
                            type="text"
                            defaultValue={'01'}
                            className="form-control text-uppercase"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            ref={txtHastaSectorCatastral}
                            onChange={handleInputChange} // Valida que solo se ingresen números
                            onBlur={handleInputBlur} // Agrega un 0 adelante si la longitud es 1
                            maxLength={2} // Limita la longitud máxima a 2 caracteres
                        />
                    </div>
                    <div className="input-group input-group-sm col-md-12 mx-auto px-0 mb-1">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Uso del inmueble:</label>
                        <select
                            className="form-select text-uppercase"
                            onChange={onChange}
                            ref={cmbUsoInmueble}
                            id="tipoContribuyente"
                        >

                            <option value="TODOS">TODOS</option>
                            <option value="RESIDENCIAL">RESIDENCIAL</option>
                            <option value="COMERCIAL">COMERCIAL</option>
                            <option value="INDUSTRIAL">INDUSTRIAL</option>
                            <option value="RECREA./DEPORTIV">RECREA./DEPORTIV</option>
                            <option value="ASISTENCIAL/SALUD">ASISTENCIAL/SALUD</option>
                            <option value="EDUCACIONAL">EDUCACIONAL</option>
                            <option value="TURISTICO">TURISTICO</option>
                            <option value="SOCIAL/CULTURAL">SOCIAL/CULTURAL</option>
                            <option value="GUBERN./ISNTITUT">GUBERN./ISNTITUT</option>
                            <option value="RELIGIOSO">RELIGIOSO</option>
                            <option value="PESQUERO">PESQUERO</option>
                            <option value="AGROINDUSTRIAL">AGROINDUSTRIAL</option>
                            <option value="AGROFORESTAL">AGROFORESTAL</option>
                            <option value="AGRICOLA">AGRICOLA</option>
                            <option value="PECUARIO">PECUARIO</option>
                            <option value="FORESTAL">FORESTAL</option>
                            <option value="MINERO">MINERO</option>
                            <option value="SIN USO">SIN USO</option>
                        </select>
                    </div>

                    <div className='row m-0 px-0 mb-2 border-azul rounded py-2 mb-1 '>
                        <label className="fw-bold col my-auto ">Tipo de Reporte</label>
                        <div className="form-check col ml-auto">
                            <input className="form-check-input my-auto" type="radio" name="tipoReporte" id="tipoReporteGeneral" defaultChecked value="0" ref={radGeneral} />
                            <label className="form-check-label my-auto" htmlFor="tipoReporteGeneral">
                                General
                            </label>
                        </div>
                        <div className="form-check col ml-auto">
                            <input className="form-check-input my-auto" type="radio" name="tipoReporte" id="tipoReporteDetallado" value="1" ref={radDetallado} />
                            <label className="form-check-label my-auto" htmlFor="tipoReporteDetallado">
                                Detallado
                            </label>
                        </div>


                    </div>

                    <div className='row m-0 px-0 mb-2 border-azul rounded py-2'>
                        <div className='col-md-4 my-auto'>
                            <div className="form-check ml-3">
                                <input className="form-check-input my-auto" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioActivo" defaultChecked value="Activo" ref={chkActivo} />
                                <label className="form-check-label my-auto" htmlFor="deudaDesdeAnioActivo">
                                    Activo
                                </label>
                            </div>
                        </div>
                        <div className='col-md-4 my-auto'>
                            <div className="form-check ml-3">
                                <input className="form-check-input my-auto" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioInactivo" value="Inactivo" ref={chkInactivo} />
                                <label className="form-check-label my-auto" htmlFor="deudaDesdeAnioInactivo">
                                    Inactivo
                                </label>
                            </div>
                        </div>

                        <div className='col-md-4 my-auto'>
                            <div className="form-check ml-3">
                                <input className="form-check-input my-auto" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioRevCerrado" value="RevCerrado" ref={chkEnproceso} />
                                <label className="form-check-label my-auto" htmlFor="deudaDesdeAnioRevCerrado">
                                    En Proceso
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="input-group input-group-sm col-md-6 mb-1 pl-0 ml-0">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Deuda desde el Año:</label>
                        <input type="text" className="form-control text-uppercase" aria-label="Sizing example input"
                            defaultValue={moment.utc().format('YYYY')} aria-describedby="inputGroup-sizing-sm" id="declararonRetenciones" ref={txtDeudaDesdeAnioInput} />
                    </div>

                    <div className="input-group input-group-sm col-md-6 mb-1 pr-0">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Al Día:</label>
                        <input type="date" defaultValue={moment.utc().format('YYYY-MM-DD')} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="declararonRetenciones" ref={txtAlDia} />
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} /* disabled={activo} */ onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>
    );
};